export const AUTH_DISABLE_AUTOLOGOUT = 'AUTH_DISABLE_AUTOLOGOUT';
export const AUTH_ENABLE_AUTOLOGOUT = 'AUTH_ENABLE_AUTOLOGOUT';
export const AUTH_SET_ACCOUNT = 'AUTH_SET_ACCCOUNT';
